// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./font/fredoka-one/FredokaOne-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABZ0RVh0Q3JlYXRpb24gVGltZQAxMC8yOS8xMiKqq3kAAAAcdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzVxteM2AAABHklEQVRIib2Vyw6EIAxFW5idr///Qx9sfG3pLEyJ3tAwi5EmBqRo7vHawiEEERHS6x7MTMxMVv6+z3tPMUYSkfTM/R0fEaG2bbMv+Gc4nZzn+dN4HAcREa3r+hi3bcuu68jLskhVIlW073tWaYlQ9+F9IpqmSfq+fwskhdO/AwmUTJXrOuaRQNeRkOd5lq7rXmS5InmERKoER/QMvUAPlZDHcZRhGN4CSeGY+aHMqgcks5RrHv/eeh455x5KrMq2yHQdibDO6ncG/KZWL7M8xDyS1/MIO0NJqdULLS81X6/X6aR0nqBSJcPeZnlZrzN477NKURn2Nus8sjzmEII0TfMiyxUuxphVWjpJkbx0btUnshRihVv70Bv8ItXq6Asoi/ZiCbU6YgAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./font/libre-franklin/LibreFranklin-Regular.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: Fredoka;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@media (prefers-reduced-motion: no-preference) {
    .App-logo {
        animation: App-logo-spin infinite 20s linear;
    }
}


.tilligw .page-404 {
    min-height: 100vh;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.tilligw .error-template {
    padding: 40px 15px;
    text-align: center;
}

.tilligw .center-form-div {
    justify-content: center;
    display: flex;
    align-items: center;
    margin: auto;
}

.tilligw .center-box {
    overflow: auto;
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

.tilligw .bg-color-box {
    background-color: #fedb00;
}

.tilligw .boy-image {
    float: left;
}

.tilligw .girl-image {
    float: right;
}

.tilligw .girl-image>img,
.boy-image>img {
    width: 20%;
    height: auto;
}

.tilligw .girl-image>img {
    position: absolute;
    bottom: 0px;
}

.tilligw .boy-image>img {
    position: absolute;
    bottom: 0px;
}

.tilligw .img-box-width {
    width: 80%;
}

.tilligw .tilli-header-text {
    font-size: 8em;
    text-align: center;
    line-height: 0.8 !important;
    color: #DD3B96;
    padding-bottom: 20px;
}

.tilligw .tilli-header {
    margin-top: 20%;
}

.tilligw .tilli-sub-text {
    text-align: center;
    font-size: 15px;
    justify-content: center;
    display: flex;
    color: #000000;
    font-family: LibreFranklin-Regular;
    font-weight: 300;
}




.tilligw .dot-typing {
    position: relative;
    left: -10027px;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    background-color: #9880ff;
    color: #9880ff;
    box-shadow: 9984px 0 0 0 #D72B27, 10024px 0 0 0 #2D85DE, 10064px 0 0 0 #0F9403, 10104px 0 0 0 #7237C5;
    animation: dotTyping 1s infinite linear;
}

@keyframes dotTyping {
    0% {
        box-shadow: 9984px 0 0 0 #D72B27, 10024px 0 0 0 #2D85DE, 10064px 0 0 0 #0F9403, 10104px 0 0 0 #7237C5;
    }

    12.5% {
        box-shadow: 9984px -20px 0 0 #D72B27, 10024px 0 0 0 #2D85DE, 10064px 0 0 0 #0F9403, 10104px 0 0 0 #7237C5;
    }

    25% {
        box-shadow: 9984px 0 0 0 #D72B27, 10024px 0 0 0 #2D85DE, 10064px 0 0 0 #0F9403, 10104px 0 0 0 #7237C5;
    }

    37.5% {
        box-shadow: 9984px 0 0 0 #D72B27, 10024px -20px 0 0 #2D85DE, 10064px 0 0 0 #0F9403, 10104px 0 0 0 #7237C5;
    }

    50% {
        box-shadow: 9984px 0 0 0 #D72B27, 10024px 0 0 0 #2D85DE, 10064px 0 0 0 #0F9403, 10104px 0 0 0 #7237C5;
    }

    62.5% {
        box-shadow: 9984px 0 0 0 #D72B27, 10024px 0 0 0 #2D85DE, 10064px -20px 0 0 #0F9403, 10104px 0 0 0 #7237C5;
    }

    75% {
        box-shadow: 9984px 0 0 0 #D72B27, 10024px 0 0 0 #2D85DE, 10064px 0 0 0 #0F9403, 10104px 0 0 0 #7237C5;
    }

    87.5% {
        box-shadow: 9984px 0 0 0 #D72B27, 10024px 0 0 0 #2D85DE, 10064px 0 0 0 #0F9403, 10104px -20px 0 0 #7237C5;
    }

    100% {
        box-shadow: 9984px 0 0 0 #D72B27, 10024px 0 0 0 #2D85DE, 10064px 0 0 0 #0F9403, 10104px 0 0 0 #7237C5;
    }
}

.tilligw .dot-row {
    justify-content: center;
    text-align: center;
    display: flex;
}

.tilligw .input-style {
    color: #DD3B96;
    font-weight: 500;
    font-size: 20px;
}

.tilligw .text-center {
    text-align: center;
}

.tilligw .label-center {
    justify-content: center;
    display: flex;
}

.tilligw .css-1okebmr-indicatorSeparator {
    background-color: #fff !important
}

.tilligw .css-1s2u09g-control {
    border-radius: 30px !important;
}

.tilligw .css-1pahdxg-control,
.css-1pahdxg-control:hover,
.css-b62m3t-container {
    border: none !important;
    box-shadow: none !important;
    border-radius: 30px !important;
}

.tilligw .css-2613qy-menu {
    border-radius: 30px !important;
}

.tilligw .language-btn-style {
    background-color: rgb(221, 59, 150);
    font-size: 17px;
    padding: 7px;
    color: #FFFFFF;
    border-radius: 20px;
    line-height: 20px;
    cursor: pointer;
    font-weight: 500;
}

.tilligw .background-splash {
    display: flex;
    height: 100%;
    flex-direction: column;
}

.tilligw .background-splash .logo-setup {
    flex: 1 1;
    align-items: center;
    /* justify-content: end; */
    display: flex;
    flex-direction: column;
}

.tilligw .background-splash .splash-loader {
    flex: 1 1;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
}

/* @media only screen and (orientation:portrait) {
   .main-container {
     height: 100vw;
     -webkit-transform: rotate(90deg);
     -moz-transform: rotate(90deg);
     -o-transform: rotate(90deg);
     -ms-transform: rotate(90deg);
     transform: rotate(90deg);
   }
 } */

.main-container {
    height: 100vh;
    background-color: #fedb00;
    font-family: 'Fredoka';
}

.page-setup {
    display: flex;
    height: 100%;
    flex-direction: column;
    overflow: auto;
}

.tilligw .page-setup .language-select {
    flex: 1 1;
    padding: 2em 0;
}

.tilligw .page-setup .language-select-button {
    /* padding: 2em 0; */
    margin-top: 5px;
    margin-bottom: 80px;
}

@media only screen and (orientation:landscape) {
    .main-container {
        transform: rotate(0deg);
    }
}

.tilligw .site-color {
    color: #DD3B96
}

.tilligw .bold-text-style {
    color: #333333;
    font-weight: 500;
    font-style: normal;
}

.tilligw .text-input-style {
    border-radius: 20px;
    font-weight: normal;
}

.tilligw .pwd-hidden-text {
    position: absolute;
    top: 3px;
    right: 20px;
    z-index: 2;
    display: block;
    width: 15%;
    line-height: 30px;
    text-align: center;
    padding: 5px;
    font-weight: 600;
    color: #333333;
    cursor: pointer;
}

.tilligw .password-text {
    padding-right: 9%;
    flex: 1 1;
}

.tilligw .div-password {
    display: flex;
}

.tilligw .div-vertical-center {
    justify-content: center;
    align-items: center;
    display: flex;
    margin: auto;
}

.tilligw .gmail-div {
    display: inline-flex;
    background-color: #fff;
    border-radius: 25px;
    padding: 5px 25px;
}

.tilligw .gmail-text-div {
    flex: 1 1;
    margin: auto;
    padding: 0 20px;
}

.tilligw .gmail-img {
    width: 30px;
    height: 25px;
}

.tilligw .register-text-align {
    text-align: right;
}

.tilligw .row-password {
    flex: 1 1;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.row-dots {
    display: flex;
    justify-content: center;
}

.tilligw .passsword-dots {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #fcdb4b;
    margin: 0 10px;
    border: 3px solid #333333;
}

.tilligw .passsword-dots.active {
    background-color: #333333;
}

.tilligw .row-number {
    display: flex;
}

.tilligw .row-number .number {
    flex: 1 1;
    padding: 5px;
    font-size: 25px;
    font-weight: bold;
}

.tilligw .row-number .delete {
    display: inline-block;
    background: #333333;
    /* padding: 2px 10px; */
    position: relative;
    height: 28px;
    padding: 0 10px;
    line-height: 24px;
}

.tilligw .row-number .delete:before {
    content: "\\A";
    border-style: solid;
    border-width: 12px 12px 12px 0;
    border-color: transparent #333333 transparent transparent;
    position: absolute;
    top: 0px;
    left: -12px;
}

.tilligw .row-number .delete i {
    color: #FAD202;
}

.tilligw .site-txt-black {
    color: #333333;
}

.tilligw .fnt-style {
    font-style: normal;
    font-weight: 500;
}

.text-end {
    text-align: end;
}

.tilligw .child-card-body {
    background-color: #fff;
    border-radius: 25px;
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 1px 1px 2px #ad9810
}

.tilligw .create-pro-boy {
    width: 65%;
    height: auto;
}

.tilligw .create-pro-girl {
    width: 55%;
    height: auto;
}

.tilligw .error-text {
    color: red;
    font-size: 12px;
}

.tilligw .language-btn-style.disabled {
    background: #ec8fc3;
    color: #f6cae3;
}

.tilligw .child-card-body.active {
    background-color: #dd4197;
    box-shadow: 1px 1px 2px #d0b500
}

.tilligw .child-card-body.active .site-color {
    color: #fff;
}

.tilligw .game-play {
    touch-action: none;
    margin: 0;
    border: 0 none;
    padding: 0;
    text-align: center;
    background-color: black;
    height: 100%;
    width: 100%;
}

.tilligw .game-play #canvas {
    display: block;
    margin: 0;
    color: white;
}

.tilligw .game-play #canvas:focus {
    outline: none;
}

.tilligw .game-play .godot {
    font-family: 'Noto Sans', 'Droid Sans', Arial, sans-serif;
    color: #e0e0e0;
    background-color: #3b3943;
    background-image: linear-gradient(to bottom, #403e48, #35333c);
    border: 1px solid #45434e;
    box-shadow: 0 0 1px 1px #2f2d35;
}


/* Status display
  * ============== */

.tilligw .game-play #status {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    /* don't consume click events - make children visible explicitly */
    visibility: hidden;
}

.tilligw .game-play #status-progress {
    width: 366px;
    height: 7px;
    background-color: #38363A;
    border: 1px solid #444246;
    padding: 1px;
    box-shadow: 0 0 2px 1px #1B1C22;
    border-radius: 2px;
    visibility: visible;
}

@media only screen and (orientation:portrait) {
    .tilligw .game-play #status-progress {
        width: 61.8%;
    }
}

.tilligw .game-play #status-progress-inner {
    height: 100%;
    width: 0;
    box-sizing: border-box;
    transition: width 0.5s linear;
    background-color: #202020;
    border: 1px solid #222223;
    box-shadow: 0 0 1px 1px #27282E;
    border-radius: 3px;
}

.tilligw .game-play #status-indeterminate {
    visibility: visible;
    position: relative;
}

.tilligw .game-play #status-indeterminate>div {
    width: 4.5px;
    height: 0;
    border-style: solid;
    border-width: 9px 3px 0 3px;
    border-color: #2b2b2b transparent transparent transparent;
    transform-origin: center 21px;
    position: absolute;
}

.tilligw .game-play #status-indeterminate>div:nth-child(1) {
    transform: rotate(22.5deg);
}

.tilligw .game-play #status-indeterminate>div:nth-child(2) {
    transform: rotate(67.5deg);
}

.tilligw .game-play #status-indeterminate>div:nth-child(3) {
    transform: rotate(112.5deg);
}

.tilligw .game-play #status-indeterminate>div:nth-child(4) {
    transform: rotate(157.5deg);
}

.tilligw .game-play #status-indeterminate>div:nth-child(5) {
    transform: rotate(202.5deg);
}

.tilligw .game-play #status-indeterminate>div:nth-child(6) {
    transform: rotate(247.5deg);
}

.tilligw .game-play #status-indeterminate>div:nth-child(7) {
    transform: rotate(292.5deg);
}

.tilligw .game-play #status-indeterminate>div:nth-child(8) {
    transform: rotate(337.5deg);
}

.tilligw .game-play #status-notice {
    margin: 0 100px;
    line-height: 1.3;
    visibility: visible;
    padding: 4px 6px;
    visibility: visible;
}

@media (max-width: 576px) {
    .tilligw .register-text-align {
        text-align: left;
        padding: 0 20px;
    }

    .tilligw .text-end {
        text-align: left;
    }
}

@font-face {
    font-family: FredokaOne-Regular;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}


@font-face {
    font-family: LibreFranklin-Regular;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.tilligw div,
.tilligw p,
.tilligw span {
    font-family: FredokaOne-Regular;
}

.tilligw .libre-franklin-reg {
    font-family: LibreFranklin-Regular !important;
}

.tilligw .fredokaone-reg {
    font-family: LibreFranklin-Regular !important;
}

.tilligw ::placeholder {
    font-family: LibreFranklin-Regular !important;
    font-style: italic;
    font-weight: 500;
    color: #333333;
    font-size: 15px;
}

.tilligw h1,
.tilligw h2,
.tilligw h3,
.tilligw h4 .tilligw h5 {
    font-family: FredokaOne-Regular;
}

.tilligw .maxwidth {
    max-width: 25%;
}

@media screen and (min-width: 900px) {
    .tilligw .maxwidth {
        max-width: 0%;
    }

    .tilligw .row-number .number {
        font-size: 30px !important;
        padding: 7px;
    }

    .tilligw .btn-max-width {
        max-width: 55%;
        margin: auto;
    }

}

.tilligw .btn-regi {
    max-width: 55%;
    margin: auto;
}

.tilligw input[type=text],
.tilligw input[type=password] {
    width: 100%;
    padding: 0px 15px;
    margin: 3px;
    display: inline-block;
    border: 1px solid #18191F;
    box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./src/tilligameweb.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,4CAAqD;AACzD;;AAEA;IACI;QACI,4CAA4C;IAChD;AACJ;;;AAGA;IACI,iBAAiB;IACjB,yDAA6oB;AACjpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,2BAA2B;IAC3B,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,kCAAkC;IAClC,gBAAgB;AACpB;;;;;AAKA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,qGAAqG;IACrG,uCAAuC;AAC3C;;AAEA;IACI;QACI,qGAAqG;IACzG;;IAEA;QACI,yGAAyG;IAC7G;;IAEA;QACI,qGAAqG;IACzG;;IAEA;QACI,yGAAyG;IAC7G;;IAEA;QACI,qGAAqG;IACzG;;IAEA;QACI,yGAAyG;IAC7G;;IAEA;QACI,qGAAqG;IACzG;;IAEA;QACI,yGAAyG;IAC7G;;IAEA;QACI,qGAAqG;IACzG;AACJ;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;;IAGI,uBAAuB;IACvB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mCAAmC;IACnC,eAAe;IACf,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;;;;;;;;IASI;;AAEJ;IACI,aAAa;IACb,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI;QAKI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,UAAU;IACV,cAAc;IACd,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,SAAO;AACX;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,SAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yDAAyD;IACzD,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,cAAc;IACd,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yDAAyD;IACzD,cAAc;IACd,yBAAyB;IACzB,8DAA8D;IAC9D,yBAAyB;IACzB,+BAA+B;AACnC;;;AAGA;oBACoB;;AAEpB;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,QAAQ;IACR,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kEAAkE;IAClE,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ,QAAQ;IACR,sBAAsB;IACtB,6BAA6B;IAC7B,yBAAyB;IACzB,yBAAyB;IACzB,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,yDAAyD;IACzD,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,+BAA+B;IAC/B,4CAAqD;AACzD;;;AAGA;IACI,kCAAkC;IAClC,4CAA2D;AAC/D;;AAEA;;;IAGI,+BAA+B;AACnC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;AACjD;;AAoBA;IACI,6CAA6C;IAC7C,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;;;;IAII,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,YAAY;IAChB;;AAEJ;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;AAC1B","sourcesContent":["@font-face {\n    font-family: Fredoka;\n    src: url(\"./font/fredoka-one/FredokaOne-Regular.ttf\");\n}\n\n@media (prefers-reduced-motion: no-preference) {\n    .App-logo {\n        animation: App-logo-spin infinite 20s linear;\n    }\n}\n\n\n.tilligw .page-404 {\n    min-height: 100vh;\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABZ0RVh0Q3JlYXRpb24gVGltZQAxMC8yOS8xMiKqq3kAAAAcdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzVxteM2AAABHklEQVRIib2Vyw6EIAxFW5idr///Qx9sfG3pLEyJ3tAwi5EmBqRo7vHawiEEERHS6x7MTMxMVv6+z3tPMUYSkfTM/R0fEaG2bbMv+Gc4nZzn+dN4HAcREa3r+hi3bcuu68jLskhVIlW073tWaYlQ9+F9IpqmSfq+fwskhdO/AwmUTJXrOuaRQNeRkOd5lq7rXmS5InmERKoER/QMvUAPlZDHcZRhGN4CSeGY+aHMqgcks5RrHv/eeh455x5KrMq2yHQdibDO6ncG/KZWL7M8xDyS1/MIO0NJqdULLS81X6/X6aR0nqBSJcPeZnlZrzN477NKURn2Nus8sjzmEII0TfMiyxUuxphVWjpJkbx0btUnshRihVv70Bv8ItXq6Asoi/ZiCbU6YgAAAABJRU5ErkJggg==);\n}\n\n.tilligw .error-template {\n    padding: 40px 15px;\n    text-align: center;\n}\n\n.tilligw .center-form-div {\n    justify-content: center;\n    display: flex;\n    align-items: center;\n    margin: auto;\n}\n\n.tilligw .center-box {\n    overflow: auto;\n    margin: auto;\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n}\n\n.tilligw .bg-color-box {\n    background-color: #fedb00;\n}\n\n.tilligw .boy-image {\n    float: left;\n}\n\n.tilligw .girl-image {\n    float: right;\n}\n\n.tilligw .girl-image>img,\n.boy-image>img {\n    width: 20%;\n    height: auto;\n}\n\n.tilligw .girl-image>img {\n    position: absolute;\n    bottom: 0px;\n}\n\n.tilligw .boy-image>img {\n    position: absolute;\n    bottom: 0px;\n}\n\n.tilligw .img-box-width {\n    width: 80%;\n}\n\n.tilligw .tilli-header-text {\n    font-size: 8em;\n    text-align: center;\n    line-height: 0.8 !important;\n    color: #DD3B96;\n    padding-bottom: 20px;\n}\n\n.tilligw .tilli-header {\n    margin-top: 20%;\n}\n\n.tilligw .tilli-sub-text {\n    text-align: center;\n    font-size: 15px;\n    justify-content: center;\n    display: flex;\n    color: #000000;\n    font-family: LibreFranklin-Regular;\n    font-weight: 300;\n}\n\n\n\n\n.tilligw .dot-typing {\n    position: relative;\n    left: -10027px;\n    width: 20px;\n    height: 20px;\n    border-radius: 10px;\n    background-color: #9880ff;\n    color: #9880ff;\n    box-shadow: 9984px 0 0 0 #D72B27, 10024px 0 0 0 #2D85DE, 10064px 0 0 0 #0F9403, 10104px 0 0 0 #7237C5;\n    animation: dotTyping 1s infinite linear;\n}\n\n@keyframes dotTyping {\n    0% {\n        box-shadow: 9984px 0 0 0 #D72B27, 10024px 0 0 0 #2D85DE, 10064px 0 0 0 #0F9403, 10104px 0 0 0 #7237C5;\n    }\n\n    12.5% {\n        box-shadow: 9984px -20px 0 0 #D72B27, 10024px 0 0 0 #2D85DE, 10064px 0 0 0 #0F9403, 10104px 0 0 0 #7237C5;\n    }\n\n    25% {\n        box-shadow: 9984px 0 0 0 #D72B27, 10024px 0 0 0 #2D85DE, 10064px 0 0 0 #0F9403, 10104px 0 0 0 #7237C5;\n    }\n\n    37.5% {\n        box-shadow: 9984px 0 0 0 #D72B27, 10024px -20px 0 0 #2D85DE, 10064px 0 0 0 #0F9403, 10104px 0 0 0 #7237C5;\n    }\n\n    50% {\n        box-shadow: 9984px 0 0 0 #D72B27, 10024px 0 0 0 #2D85DE, 10064px 0 0 0 #0F9403, 10104px 0 0 0 #7237C5;\n    }\n\n    62.5% {\n        box-shadow: 9984px 0 0 0 #D72B27, 10024px 0 0 0 #2D85DE, 10064px -20px 0 0 #0F9403, 10104px 0 0 0 #7237C5;\n    }\n\n    75% {\n        box-shadow: 9984px 0 0 0 #D72B27, 10024px 0 0 0 #2D85DE, 10064px 0 0 0 #0F9403, 10104px 0 0 0 #7237C5;\n    }\n\n    87.5% {\n        box-shadow: 9984px 0 0 0 #D72B27, 10024px 0 0 0 #2D85DE, 10064px 0 0 0 #0F9403, 10104px -20px 0 0 #7237C5;\n    }\n\n    100% {\n        box-shadow: 9984px 0 0 0 #D72B27, 10024px 0 0 0 #2D85DE, 10064px 0 0 0 #0F9403, 10104px 0 0 0 #7237C5;\n    }\n}\n\n.tilligw .dot-row {\n    justify-content: center;\n    text-align: center;\n    display: flex;\n}\n\n.tilligw .input-style {\n    color: #DD3B96;\n    font-weight: 500;\n    font-size: 20px;\n}\n\n.tilligw .text-center {\n    text-align: center;\n}\n\n.tilligw .label-center {\n    justify-content: center;\n    display: flex;\n}\n\n.tilligw .css-1okebmr-indicatorSeparator {\n    background-color: #fff !important\n}\n\n.tilligw .css-1s2u09g-control {\n    border-radius: 30px !important;\n}\n\n.tilligw .css-1pahdxg-control,\n.css-1pahdxg-control:hover,\n.css-b62m3t-container {\n    border: none !important;\n    box-shadow: none !important;\n    border-radius: 30px !important;\n}\n\n.tilligw .css-2613qy-menu {\n    border-radius: 30px !important;\n}\n\n.tilligw .language-btn-style {\n    background-color: rgb(221, 59, 150);\n    font-size: 17px;\n    padding: 7px;\n    color: #FFFFFF;\n    border-radius: 20px;\n    line-height: 20px;\n    cursor: pointer;\n    font-weight: 500;\n}\n\n.tilligw .background-splash {\n    display: flex;\n    height: 100%;\n    flex-direction: column;\n}\n\n.tilligw .background-splash .logo-setup {\n    flex: 1 1;\n    align-items: center;\n    /* justify-content: end; */\n    display: flex;\n    flex-direction: column;\n}\n\n.tilligw .background-splash .splash-loader {\n    flex: 1 1;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    flex-direction: column;\n}\n\n/* @media only screen and (orientation:portrait) {\n   .main-container {\n     height: 100vw;\n     -webkit-transform: rotate(90deg);\n     -moz-transform: rotate(90deg);\n     -o-transform: rotate(90deg);\n     -ms-transform: rotate(90deg);\n     transform: rotate(90deg);\n   }\n } */\n\n.main-container {\n    height: 100vh;\n    background-color: #fedb00;\n    font-family: 'Fredoka';\n}\n\n.page-setup {\n    display: flex;\n    height: 100%;\n    flex-direction: column;\n    overflow: auto;\n}\n\n.tilligw .page-setup .language-select {\n    flex: 1;\n    padding: 2em 0;\n}\n\n.tilligw .page-setup .language-select-button {\n    /* padding: 2em 0; */\n    margin-top: 5px;\n    margin-bottom: 80px;\n}\n\n@media only screen and (orientation:landscape) {\n    .main-container {\n        -webkit-transform: rotate(0deg);\n        -moz-transform: rotate(0deg);\n        -o-transform: rotate(0deg);\n        -ms-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n}\n\n.tilligw .site-color {\n    color: #DD3B96\n}\n\n.tilligw .bold-text-style {\n    color: #333333;\n    font-weight: 500;\n    font-style: normal;\n}\n\n.tilligw .text-input-style {\n    border-radius: 20px;\n    font-weight: normal;\n}\n\n.tilligw .pwd-hidden-text {\n    position: absolute;\n    top: 3px;\n    right: 20px;\n    z-index: 2;\n    display: block;\n    width: 15%;\n    line-height: 30px;\n    text-align: center;\n    padding: 5px;\n    font-weight: 600;\n    color: #333333;\n    cursor: pointer;\n}\n\n.tilligw .password-text {\n    padding-right: 9%;\n    flex: 1;\n}\n\n.tilligw .div-password {\n    display: flex;\n}\n\n.tilligw .div-vertical-center {\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    margin: auto;\n}\n\n.tilligw .gmail-div {\n    display: inline-flex;\n    background-color: #fff;\n    border-radius: 25px;\n    padding: 5px 25px;\n}\n\n.tilligw .gmail-text-div {\n    flex: 1 1 0%;\n    margin: auto;\n    padding: 0 20px;\n}\n\n.tilligw .gmail-img {\n    width: 30px;\n    height: 25px;\n}\n\n.tilligw .register-text-align {\n    text-align: right;\n}\n\n.tilligw .row-password {\n    flex: 1;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n}\n\n.row-dots {\n    display: flex;\n    justify-content: center;\n}\n\n.tilligw .passsword-dots {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    background: #fcdb4b;\n    margin: 0 10px;\n    border: 3px solid #333333;\n}\n\n.tilligw .passsword-dots.active {\n    background-color: #333333;\n}\n\n.tilligw .row-number {\n    display: flex;\n}\n\n.tilligw .row-number .number {\n    flex: 1;\n    padding: 5px;\n    font-size: 25px;\n    font-weight: bold;\n}\n\n.tilligw .row-number .delete {\n    display: inline-block;\n    background: #333333;\n    /* padding: 2px 10px; */\n    position: relative;\n    height: 28px;\n    padding: 0 10px;\n    line-height: 24px;\n}\n\n.tilligw .row-number .delete:before {\n    content: \"\\A\";\n    border-style: solid;\n    border-width: 12px 12px 12px 0;\n    border-color: transparent #333333 transparent transparent;\n    position: absolute;\n    top: 0px;\n    left: -12px;\n}\n\n.tilligw .row-number .delete i {\n    color: #FAD202;\n}\n\n.tilligw .site-txt-black {\n    color: #333333;\n}\n\n.tilligw .fnt-style {\n    font-style: normal;\n    font-weight: 500;\n}\n\n.text-end {\n    text-align: end;\n}\n\n.tilligw .child-card-body {\n    background-color: #fff;\n    border-radius: 25px;\n    width: 100px;\n    height: 100px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    box-shadow: 1px 1px 2px #ad9810\n}\n\n.tilligw .create-pro-boy {\n    width: 65%;\n    height: auto;\n}\n\n.tilligw .create-pro-girl {\n    width: 55%;\n    height: auto;\n}\n\n.tilligw .error-text {\n    color: red;\n    font-size: 12px;\n}\n\n.tilligw .language-btn-style.disabled {\n    background: #ec8fc3;\n    color: #f6cae3;\n}\n\n.tilligw .child-card-body.active {\n    background-color: #dd4197;\n    box-shadow: 1px 1px 2px #d0b500\n}\n\n.tilligw .child-card-body.active .site-color {\n    color: #fff;\n}\n\n.tilligw .game-play {\n    touch-action: none;\n    margin: 0;\n    border: 0 none;\n    padding: 0;\n    text-align: center;\n    background-color: black;\n    height: 100%;\n    width: 100%;\n}\n\n.tilligw .game-play #canvas {\n    display: block;\n    margin: 0;\n    color: white;\n}\n\n.tilligw .game-play #canvas:focus {\n    outline: none;\n}\n\n.tilligw .game-play .godot {\n    font-family: 'Noto Sans', 'Droid Sans', Arial, sans-serif;\n    color: #e0e0e0;\n    background-color: #3b3943;\n    background-image: linear-gradient(to bottom, #403e48, #35333c);\n    border: 1px solid #45434e;\n    box-shadow: 0 0 1px 1px #2f2d35;\n}\n\n\n/* Status display\n  * ============== */\n\n.tilligw .game-play #status {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    /* don't consume click events - make children visible explicitly */\n    visibility: hidden;\n}\n\n.tilligw .game-play #status-progress {\n    width: 366px;\n    height: 7px;\n    background-color: #38363A;\n    border: 1px solid #444246;\n    padding: 1px;\n    box-shadow: 0 0 2px 1px #1B1C22;\n    border-radius: 2px;\n    visibility: visible;\n}\n\n@media only screen and (orientation:portrait) {\n    .tilligw .game-play #status-progress {\n        width: 61.8%;\n    }\n}\n\n.tilligw .game-play #status-progress-inner {\n    height: 100%;\n    width: 0;\n    box-sizing: border-box;\n    transition: width 0.5s linear;\n    background-color: #202020;\n    border: 1px solid #222223;\n    box-shadow: 0 0 1px 1px #27282E;\n    border-radius: 3px;\n}\n\n.tilligw .game-play #status-indeterminate {\n    visibility: visible;\n    position: relative;\n}\n\n.tilligw .game-play #status-indeterminate>div {\n    width: 4.5px;\n    height: 0;\n    border-style: solid;\n    border-width: 9px 3px 0 3px;\n    border-color: #2b2b2b transparent transparent transparent;\n    transform-origin: center 21px;\n    position: absolute;\n}\n\n.tilligw .game-play #status-indeterminate>div:nth-child(1) {\n    transform: rotate(22.5deg);\n}\n\n.tilligw .game-play #status-indeterminate>div:nth-child(2) {\n    transform: rotate(67.5deg);\n}\n\n.tilligw .game-play #status-indeterminate>div:nth-child(3) {\n    transform: rotate(112.5deg);\n}\n\n.tilligw .game-play #status-indeterminate>div:nth-child(4) {\n    transform: rotate(157.5deg);\n}\n\n.tilligw .game-play #status-indeterminate>div:nth-child(5) {\n    transform: rotate(202.5deg);\n}\n\n.tilligw .game-play #status-indeterminate>div:nth-child(6) {\n    transform: rotate(247.5deg);\n}\n\n.tilligw .game-play #status-indeterminate>div:nth-child(7) {\n    transform: rotate(292.5deg);\n}\n\n.tilligw .game-play #status-indeterminate>div:nth-child(8) {\n    transform: rotate(337.5deg);\n}\n\n.tilligw .game-play #status-notice {\n    margin: 0 100px;\n    line-height: 1.3;\n    visibility: visible;\n    padding: 4px 6px;\n    visibility: visible;\n}\n\n@media (max-width: 576px) {\n    .tilligw .register-text-align {\n        text-align: left;\n        padding: 0 20px;\n    }\n\n    .tilligw .text-end {\n        text-align: left;\n    }\n}\n\n@font-face {\n    font-family: FredokaOne-Regular;\n    src: url(\"./font/fredoka-one/FredokaOne-Regular.ttf\");\n}\n\n\n@font-face {\n    font-family: LibreFranklin-Regular;\n    src: url(\"./font/libre-franklin/LibreFranklin-Regular.otf\");\n}\n\n.tilligw div,\n.tilligw p,\n.tilligw span {\n    font-family: FredokaOne-Regular;\n}\n\n.tilligw .libre-franklin-reg {\n    font-family: LibreFranklin-Regular !important;\n}\n\n.tilligw .fredokaone-reg {\n    font-family: LibreFranklin-Regular !important;\n}\n\n.tilligw ::-webkit-input-placeholder {\n    /* Edge */\n    font-family: LibreFranklin-Regular !important;\n    font-style: italic;\n    font-weight: 500;\n    color:#333333;\n    font-size: 15px;\n}\n\n.tilligw :-ms-input-placeholder {\n    /* Internet Explorer 10-11 */\n    font-family: LibreFranklin-Regular !important;\n    font-style: italic;\n    font-weight: 500;\n    color: #333333;\n    font-size: 15px;\n}\n\n.tilligw ::placeholder {\n    font-family: LibreFranklin-Regular !important;\n    font-style: italic;\n    font-weight: 500;\n    color: #333333;\n    font-size: 15px;\n}\n\n.tilligw h1,\n.tilligw h2,\n.tilligw h3,\n.tilligw h4 .tilligw h5 {\n    font-family: FredokaOne-Regular;\n}\n\n.tilligw .maxwidth {\n    max-width: 25%;\n}\n\n@media screen and (min-width: 900px) {\n    .tilligw .maxwidth {\n        max-width: 0%;\n    }\n\n    .tilligw .row-number .number {\n        font-size: 30px !important;\n        padding: 7px;\n    }\n\n    .tilligw .btn-max-width {\n        max-width: 55%;\n        margin: auto;\n    }\n\n}\n\n.tilligw .btn-regi {\n    max-width: 55%;\n    margin: auto;\n}\n\n.tilligw input[type=text],\n.tilligw input[type=password] {\n    width: 100%;\n    padding: 0px 15px;\n    margin: 3px;\n    display: inline-block;\n    border: 1px solid #18191F;\n    box-sizing: border-box;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
